import { Flex, Table, Typography } from "antd";
import React from "react";
import { getOpenAccountsReceivableFinancedColumns } from "financials/constants";
import { useBoundStore } from "store";
import { utilityService } from "shared/services";
import variables from "../../../_variables.scss";
import { IOpenAccountsReceivableFinanced } from "financials/models";

interface OpenAccountsReceivableFinancedProps {
  openAccountsReceivableFinanced: IOpenAccountsReceivableFinanced[];
}

export const OpenAccountsReceivableFinanced = ({ openAccountsReceivableFinanced }: OpenAccountsReceivableFinancedProps) => {
  const { currentOrganization } = useBoundStore();
  const tblRef: Parameters<typeof Table>[0]["ref"] = React.useRef(null);
  const tableColumns = getOpenAccountsReceivableFinancedColumns(currentOrganization);

  return (
    <Flex
      vertical
      gap={variables.gap}
      data-testid='openAccountsReceivableFinanced'
    >
      <h2>Open Accounts Receivable - Financed</h2>
      <Table
        columns={tableColumns}
        dataSource={openAccountsReceivableFinanced}
        ref={tblRef}
        rowKey='id'
        pagination={false}
        summary={(pageData) => {
          let totalBilledFinancedAmount = 0;
          let totalCustomerFinancedPortionReceivedAmount = 0;

          pageData.forEach(
            ({
              billedFinancedAmount,
              customerFinancedPortionReceivedAmount,
            }) => {
              totalBilledFinancedAmount += Number(billedFinancedAmount ?? 0);
              totalCustomerFinancedPortionReceivedAmount += Number(
                customerFinancedPortionReceivedAmount ?? 0
              );
            }
          );

          return (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}></Table.Summary.Cell>
                <Table.Summary.Cell index={1} colSpan={2}>
                  <Typography.Text strong>TOTALS</Typography.Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} colSpan={4}>
                  <Typography.Text strong>
                    $
                    {utilityService.statisticsFormatter(
                      totalBilledFinancedAmount
                    )}
                  </Typography.Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                  <Typography.Text strong>
                    $
                    {utilityService.statisticsFormatter(
                      totalCustomerFinancedPortionReceivedAmount
                    )}
                  </Typography.Text>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          );
        }}
        scroll={{ y: variables.defaultComponentHeight }}
      />
    </Flex>
  );
};
